import { useStore } from '../lib/store'
import '../screens/admin/admin.css'

// The in-console announcement banner. Renders every banner-eligible published
// announcement for the signed-in recruiter (audience-matched, unexpired, not yet
// dismissed); severity drives the colour. Dismissal is per-recruiter and
// persisted, so a dismissed notice stays gone across reloads. This is the
// lightest announcement channel — pull-based, no send step.
export function AnnouncementBanner() {
  const { bannerAnnouncements, dismissAnnouncement } = useStore()
  if (bannerAnnouncements.length === 0) return null
  return (
    <div className="ann-banners">
      {bannerAnnouncements.map((a) => (
        <div key={a.id} className={`ann-banner ann-banner--${a.severity}`} role="status">
          <div className="ann-banner__body">
            <div className="ann-banner__title">{a.title}</div>
            {a.body && <div className="ann-banner__text">{a.body}</div>}
          </div>
          {a.dismissible && (
            <button
              className="ann-banner__close"
              onClick={() => dismissAnnouncement(a.id)}
              aria-label="Dismiss announcement"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
